import React, { Component } from 'react';
import { View, Text } from 'react-native';
import utils from '../utils';
import Icon from '../../../Icon';
import { enabledStyle, disabledStyle } from '../commonStyles';

const statusMap: { [propName: string]: string } = {
    10: 'isWarning',
    11: 'isWarning'
};

const appActionMap: { [propName: string]: boolean } = {
    bus_pay: true,
    neworder: true
};

const titleMap: { [propName: string]: string } = {
    5002001: '汽车票'
};

const iconMap: { [propName: string]: string } = {
    5002001: '\uf1eb',
    5002002: '\uf38f'
};
interface DataModel {
    orderTitle: string;
    orderType: string;
    status: boolean;
}

class Bus extends Component<{
    data: { busList: any[]; shipShow: boolean; agentName: string; _disable: boolean };
}> {
    public static formatData = (data: DataModel) => {
        const newData: any = { ...data };

        // title
        newData.title = newData.orderTitle || titleMap[newData.orderType] || '船票';

        // icon
        newData.iconfont = iconMap[newData.orderType] || '\uf1eb';
        newData.iconColor = '#02cad4';

        // 状态
        newData._orderStatus = statusMap[newData.status];
        // 按钮
        newData.actionInfos = utils.buildActionInfos(newData.appAction, appActionMap);

        // 价格
        newData.currency = (newData.currency || '').trim();
        newData.fixPrice = utils.fixPrice(newData.price, newData.currency);
        newData.fixConvertPrice = utils.fixPrice(newData.convertPrice);
        newData.shipShow = newData.orderType === 5002002;
        if (newData.busList) {
            newData.busList = newData.busList.map((bus: any) => ({
                ...bus,
                timeLine: buildTimeLine(bus.fromDate, bus.toDate)
            }));
        }

        return newData;
    };

    public render() {
        const {
            data: { busList = [], shipShow = false, agentName = '', _disable = false } = {}
        } = this.props;
        const styles = _disable ? disabledStyle : enabledStyle;

        return (
            <View style={styles.left}>
                {busList.map((item, index) => (
                    <View key={index}>
                        {Boolean(item.fromStation || item.toStation) && (
                            <Text style={styles.newOrderTitle} numberOfLines={2}>
                                {Boolean(item.fromStation) &&
                                    `${item.fromStation}${item.toStation ? ' ' : ''}`}
                                {Boolean(item.fromStation && item.toStation) && (
                                    <Icon code="&#xe6c2;" size={14} />
                                )}
                                {Boolean(item.toStation) &&
                                    `${item.fromStation ? ' ' : ''}${item.toStation} `}
                            </Text>
                        )}
                        {Boolean(shipShow) &&
                            (item.toDate ? (
                                <Text style={styles.newOrderSubTitle}>
                                    {item.timeLine}
                                    {Boolean(item.days) && (
                                        <Text style={styles.oneMoreDay} numberOfLines={1}>
                                            {` ${item.days > 0 ? '+' : ''}${item.days}天`}
                                        </Text>
                                    )}
                                </Text>
                            ) : (
                                Boolean(item.fromDate) && (
                                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                        {`${item.fromDate} 出发`}
                                    </Text>
                                )
                            ))}
                        {!shipShow && item.realDepTime ? (
                            <View>
                                <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                    {`${item.realDepTime} 实际出发`}
                                </Text>
                                {Boolean(item.fromDate) && (
                                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                        {`${item.fromDate} 计划出发`}
                                    </Text>
                                )}
                            </View>
                        ) : (
                            Boolean(item.fromDate) && (
                                <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                    {`${item.fromDate} 出发`}
                                </Text>
                            )
                        )}
                        {Boolean(agentName) && (
                            <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                代理商&nbsp;&nbsp;
                                {agentName}
                            </Text>
                        )}
                        {Boolean(item.shipName) && (
                            <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                {item.shipName}
                                &nbsp;&nbsp;
                            </Text>
                        )}
                        {Boolean(item.shipType) && (
                            <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                {item.shipType}
                            </Text>
                        )}
                    </View>
                ))}
            </View>
        );
    }
}

const buildTimeLine = (fromDate: string, toDate: string, joiner?: string) => {
    let arrivalInfo;
    const timeLine = [];
    if (fromDate && toDate) {
        timeLine.push(fromDate.trim().slice(0, -3));
        arrivalInfo = toDate.trim().split(' ');
        timeLine.push(arrivalInfo?.[1]?.slice(0, -3) || '');
    }
    return timeLine.join(joiner || ' - ');
};

export default Bus;
